import React, { useState } from "react";
import Logo from "../Logo";
import IcCalendario from "../../components/Svg/IcCalendario";
import IcComercial from "../../components/Svg/IcComercial";
import IcAtendimento from "../../components/Svg/IcAtendimento";
import IcFinanceiro from "../../components/Svg/IcFinanceiro";
import IcTurmas from "../../components/Svg/IcTurmas";
import IcFormando from "../../components/Svg/IcFormando";
import IcFornecedores from "../../components/Svg/IcFornecedores";
import IcInstituicoes from "../../components/Svg/IcInstituicoes";
import IcBox from "../../components/Svg/IcBox";
import IcConfig from "../../components/Svg/IcConfig";
import styles from "./Menu.module.css";
import { NavLink } from "react-router-dom";
import useWrapper from "../../hooks/useWrapper";
import packageJson from "../../../package.json";

export default function Menu({ menu }) {
  const { me } = useWrapper();
  const { version } = packageJson;
  const permissions = !!me ? JSON.parse(me?.permissions) : [];
  const [subMenu, setSubMenu] = useState("");
  const setSubMenuSelect = menu => {
    if (subMenu === menu && !window.location.href.includes(menu)) {
      setSubMenu("");
    } else {
      setSubMenu(menu);
    }
  };

  return (
    <div className={`${styles.Menu} ${menu ? styles.sideMenuFull : styles.sideMenuMini} -hide-on-print`}>
      <div className={styles.logo}>
        <NavLink to="/dashboard">
          <div className={styles.bigLogo}>
            <Logo />
          </div>
        </NavLink>
      </div>
      <nav>
        <div className={styles.menuContainer}>
          <div className={styles.menuItem}>
            <NavLink to="/dashboard">
              <span className={styles.menuIco}>
                <IcCalendario />
              </span>
              <span className={styles.menuLabel}>Agenda</span>
            </NavLink>
          </div>
          {permissions?.commercial?.reading && (
            <div className={styles.menuItem}>
              <NavLink to="/business">
                <span className={styles.menuIco}>
                  <IcFornecedores />
                </span>
                <span className={styles.menuLabel}>Comerciais</span>
              </NavLink>
            </div>
          )}
          {permissions?.attendance?.reading && (
            <div className={styles.menuItem}>
              <NavLink to="/attendance">
                <span className={styles.menuIco}>
                  <IcAtendimento />
                </span>
                <span className={styles.menuLabel}>Atendimentos</span>
              </NavLink>
            </div>
          )}
          {(permissions?.financialGroup?.reading || permissions?.financialCompany?.reading) && (
            <div className={styles.menuItem}>
              <NavLink
                to="/financial/"
                onClick={__ev => {
                  setSubMenuSelect("financial");
                  __ev.preventDefault();
                }}
                className={`${subMenu === "financial" && "opened"}`}
              >
                <span className={styles.menuIco}>
                  <IcFinanceiro />
                </span>
                <span className={styles.menuLabel}>Financeiro</span>
              </NavLink>
              <div className={styles.subMenus}>
                {permissions?.financialGroup?.reading && (
                  <NavLink to="/financial/billstoreceive">
                    <span>Recebimentos</span>
                  </NavLink>
                )}
                {permissions?.financialCompany?.reading && (
                  <NavLink to="/financial/billstopay">
                    <span>Pagamentos</span>
                  </NavLink>
                )}
              </div>
            </div>
          )}
          {permissions?.commercial?.reading && (
            <div className={styles.menuItem}>
              <NavLink to="/groups">
                <span className={styles.menuIco}>
                  <IcTurmas />
                </span>
                <span className={styles.menuLabel}>Turmas</span>
              </NavLink>
            </div>
          )}
          {permissions?.trainee?.reading && (
            <div className={styles.menuItem}>
              <NavLink to="/trainees">
                <span className={styles.menuIco}>
                  <IcFormando />
                </span>
                <span className={styles.menuLabel}>Formandos</span>
              </NavLink>
            </div>
          )}
          {permissions?.suppliers?.reading && (
            <div className={styles.menuItem}>
              <NavLink to="/suppliers">
                <span className={styles.menuIco}>
                  <IcBox />
                </span>
                <span className={styles.menuLabel}>Fornecedores</span>
              </NavLink>
            </div>
          )}
          {permissions?.institutions?.reading && (
            <div className={styles.menuItem}>
              <NavLink to="/institutions">
                <span className={styles.menuIco}>
                  <IcInstituicoes />
                </span>
                <span className={styles.menuLabel}>Instituições</span>
              </NavLink>
            </div>
          )}
          {permissions?.reports?.reading && (
            <div className={styles.menuItem}>
              <NavLink
                to="/reports"
                onClick={__ev => {
                  setSubMenuSelect("reports");
                  __ev.preventDefault();
                }}
                className={`${subMenu === "reports" && "opened"}`}
              >
                <span className={styles.menuIco}>
                  <IcComercial />
                </span>
                <span className={styles.menuLabel}>Relatórios</span>
              </NavLink>
              <div className={styles.subMenus}>
                <NavLink to="/reports/chat-ia">
                  <span>
                    Chat I.A. <span className="small-label d-inline p-0">(Beta)</span>
                  </span>
                </NavLink>
                <NavLink to="/reports/attendance">
                  <span>Atendimento</span>
                </NavLink>
                <NavLink to="/reports/business">
                  <span>Comercial</span>
                </NavLink>
                <NavLink to="/reports/events">
                  <span>Eventos</span>
                </NavLink>
                <NavLink to="/reports/financial">
                  <span>Financeiro</span>
                </NavLink>
                <NavLink to="/reports/trainees">
                  <span>Formandos</span>
                </NavLink>
                <NavLink to="/reports/additional-items">
                  <span>Itens Adicionais</span>
                </NavLink>
                <NavLink to="/reports/operational">
                  <span>Operacional</span>
                </NavLink>
                <NavLink to="/reports/calendar">
                  <span>Tarefas</span>
                </NavLink>
                <NavLink to="/reports/groups">
                  <span>Turmas</span>
                </NavLink>
                <NavLink to="/reports/operational-suppliers">
                  <span>Fornecedores</span>
                </NavLink>
              </div>
            </div>
          )}
          {!!me?.is_admin && (
            <div className={styles.menuItem}>
              <NavLink
                to="/admin"
                onClick={__ev => {
                  __ev.preventDefault();
                  setSubMenuSelect("admin");
                }}
                className={`${subMenu === "admin" && "opened"} ${window.location.href.includes("admin") && "active"}`}
              >
                <span className={styles.menuIco}>
                  <IcConfig />
                </span>
                <span className={styles.menuLabel}>Administrativo</span>
              </NavLink>
              <div className={styles.subMenus}>
                <NavLink to="/admin/cost-center">
                  <span>Centro de Custo</span>
                </NavLink>
                <NavLink to="/admin/events">
                  <span>Eventos e Solenidades</span>
                </NavLink>
                <NavLink to="/admin/resources">
                  <span>Recursos e Atendimentos</span>
                </NavLink>
                <NavLink to="/admin/calendar">
                  <span>Calendário</span>
                </NavLink>
                <NavLink to="/admin/competitors">
                  <span>Concorrentes</span>
                </NavLink>
                <NavLink to="/admin/users">
                  <span>Usuários</span>
                </NavLink>
                <NavLink to="/admin/presets-permissions">
                  <span>Modelos de Permissões</span>
                </NavLink>
                <NavLink to="/admin/white-label">
                  <span>Aparência</span>
                </NavLink>
              </div>
            </div>
          )}
        </div>
      </nav>

      <div className={`${styles.version} mt-4`}>
        <span className="op-5">Desenvolvido por</span>{" "}
        <b>
          <a href="https://entaoformou.com.br/" style={{ color: "#7c309c" }} target="_blank" rel="noopener noreferrer">
            Form<span style={{ color: "#53B9C7" }}>ou</span>
          </a>
        </b>
        <NavLink to="/changelog" title="Ver changelogs" className={`small-label m-0 ${styles.versionLink}`}>
          Versão {version}
        </NavLink>
      </div>
    </div>
  );
}
